import {
  platformCRMCardsOne,
  platformCRMCardsTwo,
} from "./dashboard-platforms-section.constant";

export const getPlatformCRMCardsOne = (loginUserRolePermissions: any = []) => {
  const platformCRMCards = platformCRMCardsOne?.map((item: any) => {
    const resource = loginUserRolePermissions?.find(
      (dataItem: any) => dataItem?.resource === item?.key,
    );
    const resourceItem = item?.sections?.map((dataItem: any) => {
      const isShowResource = resource?.subresources?.find(
        (permission: any) => permission?.resource === dataItem?.sectionsName,
      );
      return {
        ...dataItem,
        isShowSubCard: isShowResource?.scopes?.read ? true : false,
      };
    });
    const isShowCard = resourceItem?.find(
      (dataItem: any) => dataItem?.isShowSubCard,
    );
    return {
      ...item,
      sections: resourceItem,
      isShowCard: isShowCard?.isShowSubCard,
    };
  });
  return platformCRMCards;
};

export const getPlatformCRMCardsTwo = (loginUserRolePermissions: any = []) => {
  const platformCRMCards = platformCRMCardsTwo?.map((item: any) => {
    if (item?.key === "Guides") {
      const supportResource = loginUserRolePermissions?.find(
        (permission: any) => permission?.resource === "Support",
      );
      const ticketResource = loginUserRolePermissions?.find(
        (permission: any) => permission?.resource === "Tickets",
      );
      const canReadSupport = supportResource?.scopes?.read;
      const canReadTickets = ticketResource?.scopes?.read;
      const sections = item?.sections?.map((section: any) => {
        let isShowSubCard = false;

        if (section?.sectionsName === "Tutorial Videos") {
          isShowSubCard = true;
        } else if (section?.sectionsName === "Request Support") {
          isShowSubCard = Boolean(canReadSupport);
        } else if (section?.sectionsName === "View Tickets") {
          isShowSubCard = Boolean(canReadTickets);
        }

        return { ...section, isShowSubCard };
      });
      let title = item?.title;

      if (canReadSupport) {
        title = "Guides & Support";
      } else if (canReadTickets) {
        title = "Guides & Tickets";
      }

      return {
        ...item,
        title,
        sections,
        isShowCard: true,
      };
    }

    const resource = loginUserRolePermissions?.find(
      (dataItem: any) => dataItem?.resource === item?.key,
    );
    const resourceItem = item?.sections?.map((dataItem: any) => {
      const isShowResource = resource?.subresources?.find(
        (permission: any) => permission?.resource === dataItem?.sectionsName,
      );
      return {
        ...dataItem,
        isShowSubCard: isShowResource?.scopes?.read ? true : false,
      };
    });
    const isShowCard = resourceItem?.find(
      (dataItem: any) => dataItem?.isShowSubCard,
    );
    return {
      ...item,
      sections: resourceItem,
      isShowCard: isShowCard?.isShowSubCard,
    };
  });
  return platformCRMCards;
};
